import { NbSkuConfig } from './types';
import { DEFAULT_CONFIG } from './constants';

const newBuyersSkuConfig = (state: NbSkuConfig = DEFAULT_CONFIG) => state;

export default newBuyersSkuConfig;
